
import { defineComponent } from "vue";
import { UniqueID } from "@/Features/uuid";

export default defineComponent({
  name: "BaseInput",
  props: {
    label: {
      type: String,
    },
    modelValue: {
      type: [String, Number],
    },
    error: {
      type: String,
      default: "",
    },
  },
  setup() {
    const uuid: number = UniqueID();
    return { uuid };
  },
});
